import gql from "fraql";
// @ts-ignore
import AppShowCountry from "@AppShows/AppShowCountry.vue";
export default {
    registrationFields: gql `
    fragment _ on Registration {
      prizeMoneyPayoutMethod
      prizeMoneyPayoutSportFundAthleteId
    }
  `,
    prizeMoneyPayoutContactFields: gql `
    fragment _ on Contact {
      id
      contactType
      name
      registryCode
      vatCode
      iban
      swiftBicCode
      registryCountryId
      registryCountry @client {
        id
        ${AppShowCountry.fragments.country}
      }

      addressText
      addressHouse
      addressIndex
      addressCity
      addressCountryId
      addressCountry @client {
        id
        ${AppShowCountry.fragments.country}
      }

      incomeTaxPercentage
      incomeTaxCardExpirationDate
      incomeTaxCardFilePath
    }
  `
};
